/**
 * BudgetFundingSourceTypeService
 * Service for BudgetFundingSourceType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetFundingSourceType CRUD operations */
export class BudgetFundingSourceTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetFundingSourceTypeService.DEFAULT_SERVICE_PATH,
            basePath: BudgetFundingSourceTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetFundingSourceTypeService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetFundingSourceTypeService.BASE_PATH = 'api/budgetfundingsourcetypes';
//# sourceMappingURL=BudgetFundingSourceTypeService.js.map